import { Table } from 'semantic-ui-react'
import React from 'react';
import { useTable } from 'react-table'

export const CustomerTable = ({ columns, data, getTrProps }) => {
	const {
		getTableProps,
		headerGroups,
		getTableBodyProps,
		rows,
		prepareRow,
	} = useTable({ columns, data })
	return (
		<Table {...getTableProps()}>
			<Table.Header>
				{
					headerGroups.map(hg => (
						<Table.Row {...hg.getHeaderGroupProps()}>
							{
								hg.headers.map(column => (
									<Table.HeaderCell {...column.getHeaderProps()}>
										{column.render("Header")}
									</Table.HeaderCell>
								))
							}
						</Table.Row>
					)
					)
				}
			</Table.Header>
			<Table.Body {...getTableBodyProps()}>
				{
					rows.map(row => {
						prepareRow(row)
						return (
							<Table.Row {...row.getRowProps()} onClick={()=>getTrProps(row)}>
								{row.cells.map(cell => {
									return <Table.Cell {...cell.getCellProps()}>{cell.render('Cell')}</Table.Cell>
								})}
							</Table.Row>
						)
					})
				}
			</Table.Body>
		</Table>
	)

} 
